module.exports = __webpack_public_path__ + "static/media/cahrt-3.e09b4125.png";